/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CompareTo = {
    PreviousPeriod: 'previous_period',
    SamePeriodLastYear: 'same_period_last_year'
} as const;
export type CompareTo = typeof CompareTo[keyof typeof CompareTo];

